import AddressWithHeading from 'lib/components/AddressWithHeading/AddressWithHeading'
import CruiseDetails from 'lib/components/CruiseDetails/CruiseDetails'
import Icon from 'lib/components/Icon/Icon'
import ServiceProviderLogo from 'lib/components/ServiceProviderLogo/ServiceProviderLogo'
import { ShipmentDetailsModalProps } from '../ShipmentDetailsModal'

export interface ShipmentDetailsModalRouteProps {
  shipper: ShipmentDetailsModalProps['shipper']
  origin: ShipmentDetailsModalProps['origin']
  destination: ShipmentDetailsModalProps['destination']
  originIsCruise?: boolean
  destinationIsCruise?: boolean
  cruise?: ShipmentDetailsModalProps['cruise']
  canViewAddresses?: boolean
}

export default function ShipmentDetailsModalRoute({
  shipper,
  origin,
  destination,
  originIsCruise = false,
  destinationIsCruise = false,
  cruise,
  canViewAddresses = false,
}: ShipmentDetailsModalRouteProps) {
  // If user doesn't have permission, show only city and state
  const originAddressLines = canViewAddresses
    ? ([
        origin.company_name || origin.attention_name,
        origin.address_1,
        origin.address_2,
        `${origin.city}, ${origin.state} ${origin.zip}, ${origin.country}`,
      ].filter(Boolean) as string[])
    : [`${origin.city}, ${origin.state}`]

  const destinationAddressLines = canViewAddresses
    ? ([
        destination.company_name || destination.attention_name,
        destination.address_1,
        destination.address_2,
        `${destination.city}, ${destination.state} ${destination.zip}, ${destination.country}`,
      ].filter(Boolean) as string[])
    : [`${destination.city}, ${destination.state}`]

  return (
    <div className="rounded-8 bg-neutral-200 px-4 py-6 lg:flex-1">
      <ServiceProviderLogo
        provider={shipper}
        className="[&]:![--ratio-height:20] [&]:h-5"
      />
      <div className="flex flex-col items-start gap-4 mt-4 lg:flex-row lg:flex-nowrap lg:justify-between lg:items-start">
        <div className="flex flex-col items-start gap-2">
          <AddressWithHeading
            heading="Origin"
            childrenClassNames={{
              heading: '[&]:text-sm',
              icon: '[&]:w-4 [&]:h-4 [&]:mr-1',
            }}
            headingLevel="h3"
            addressLines={originAddressLines}
          />
          {originIsCruise && (
            <CruiseDetails
              cruise={cruise}
              portName={cruise?.disembarkation_port}
              className="mt-1"
            />
          )}
        </div>
        <div className="text-theme-accessibility">
          <Icon icon="arrow-down" className="w-6 h-6 lg:hidden" />
          <Icon icon="arrow-right" className="w-6 h-6 md-max:hidden" />
        </div>
        <div className="flex flex-col items-start gap-2">
          <AddressWithHeading
            heading="Destination"
            childrenClassNames={{
              heading: '[&]:text-sm',
              icon: '[&]:w-4 [&]:h-4 [&]:mr-1',
            }}
            headingLevel="h3"
            addressLines={destinationAddressLines}
          />
          {destinationIsCruise && (
            <CruiseDetails
              cruise={cruise}
              portName={cruise?.embarkation_port}
              className="mt-1"
            />
          )}
        </div>
      </div>
    </div>
  )
}
